import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Careers.css";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";

const CurrentOpenings = () => {
  return (
    <div>
      <Helmet>
        <title>Current Openings | Idexcel</title>
        <meta
          content="current openings usa, current openings india"
          name="keywords"
        />
        <meta
          content="Ready to explore a career with Idexcel? Click here and explore our job openings."
          name="description"
        />
      </Helmet>

      <motion.div
        className="Productright"
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <Container fluid className="careers-banner-container p-0">
          <section className="careers-inner-banner-section"></section>
        </Container>
      </motion.div>

      <section>
        <Container className="my-5 px-xl-5">
          <section
            className="openings  d-flex flex-column align-items-center"
            style={{ textAlign: "justify" }}
          >
            <Row className="m-0 p-0 mb-5">
              {/* <h1 className="fw-normal fontsize mb-2">Software Engineer</h1> */}
              <h1 className="fw-normal fontsize mb-2">
                <span className="textgrad"> Software </span>Engineer
              </h1>
              <p className="py-2">
                Idexcel is seeking a Software Engineer to develop and test
                customized applications and software solutions. The candidate
                will collaborate with architects and product owners to
                prioritize tasks, contribute to a culture of continuous
                improvement by driving enhancements, and adhere to best
                practices. Responsibilities include participating in planning
                sessions, providing progress updates to stakeholders, resolving
                issues, facilitating code reviews, and enhancing team
                productivity. The role also involves delivering high-quality
                software aligned with business objectives using technologies and
                tools such as Java, AWS, DevOps, Python, Azure, Machine
                Learning, Node JS, React, Oracle, and UNIX.
              </p>
              <p className="py-2">
                Accept a Master's degree (or foreign education equivalent to
                same) either in Computer Science, Computer Applications,
                Information Systems, Information Technology, Science,
                Technology, Business, Engineering (any), or a related field. No
                telecommuting. EOE. Full-time, 40 hrs/week. Work in Herndon, VA,
                and other unanticipated locations within Washington DC MSA. May
                require travel/relocation to customer locations, with
                approximately 20% travel within the Washington DC MSA,
                influenced by factors such as project phases initial set-up or
                final implementation or client requirements, and the project's
                nature. Work schedule 8am-5pm, Mon-Fri. Send resume to
                JOB#IDM024, HR Dept., Idexcel Inc, 459 Herndon Pkwy, Suite #10,
                Herndon, VA 20170 (or)
                <a
                  href="mailto:usrecruitment@idexcel.com"
                  className="text-danger textDecoration"
                >
                  {" "}
                  usrecruitment@idexcel.com
                </a>
              </p>
              <div className="d-flex justify-content-end fs-6 mt-1">
                <b className="fw-semibold mx-2">Posted Date:</b> 11/18/2024
              </div>
            </Row>
            <Row className="m-0 p-0 mb-5">
              <h1 className="fw-normal fontsize mb-2">
                <span className="textgrad"> Senior </span>Software Engineer
              </h1>
              <p className="py-2">
                Idexcel is seeking a Senior Software Engineer to perform
                end-to-end analysis, design, development, testing,
                implementation, and maintenance of customized applications and
                software solutions. The candidate will collaborate with
                architects and product owners to prioritize tasks, contribute to
                a culture of continuous improvement by driving enhancements, and
                adhere to best practices. Additionally, participate in planning
                sessions, provide progress feedback to stakeholders, ensure
                issue resolution, facilitate code reviews, and work to enhance
                team productivity while delivering high-quality software aligned
                with business objectives.
              </p>
              <p className="py-2">
                Applicants must have a minimum of 1 year of work experience in
                IT positions and demonstrate proficiency in using the
                technologies and tools specified herein, including but not
                limited to Java, AWS, DevOps, Python, Azure, Machine Learning,
                SDET, Node JS, React, Oracle, and UNIX, to effectively perform
                job responsibilities.
              </p>
              <p className="py-2">
                Accept a Master's degree (or foreign education equivalent to
                same) either in Computer Science, Computer Applications,
                Information Technology, Information Systems, Science,
                Technology, Business, Engineering (any), or a related field. The
                employer is open to considering any suitable combination of
                education, training, or experience. No telecommuting. EOE.
                Full-time, 40 hrs/week. Work in Herndon, VA, and other
                unanticipated locations within Washington DC MSA. May require
                travel/relocation to customer locations, with approximately 20%
                travel within the Washington DC MSA, depending on factors such
                as project phases initial set-up or final implementation or
                client requirements, and the project's nature. Work schedule
                8am-5pm, Mon-Fri. Send resume to JOB#IDM124, HR Dept., Idexcel
                Inc, 459 Herndon Pkwy, Suite #10, Herndon, VA 20170 (or)
                <a
                  href="mailto:usrecruitment@idexcel.com"
                  className="text-danger textDecoration"
                >
                  {" "}
                  usrecruitment@idexcel.com
                </a>
              </p>
              <div className="d-flex justify-content-end fs-6 mt-1">
                <b className="fw-semibold mx-2">Posted Date:</b> 11/18/2024
              </div>
            </Row>
            <Row className="m-0 p-0 mb-3">
              <h1 className="fw-normal fontsize mb-2">
                {" "}
                <span className="textgrad"> Software </span> Engineer
              </h1>
              <p className="py-2">
                Idexcel is seeking a Software Engineer to perform end-to-end
                analysis, design, development, testing, and maintenance of
                customized applications and software solutions. The candidate
                will collaborate with architects and product owners to
                prioritize tasks, contribute to a culture of continuous
                improvement by driving enhancements, and adhere to best
                practices. Additionally, participate in planning sessions,
                provide progress feedback to stakeholders, ensure issue
                resolution, facilitate code reviews, and work to enhance team
                productivity while delivering high-quality software aligned with
                business objectives.
              </p>
              <p className="py-2">
                Applicants must have a minimum of 1 year of work experience in
                IT positions and demonstrate proficiency in using the
                technologies and tools specified herein, including but not
                limited to Java, AWS, DevOps, Python, Azure, Machine Learning,
                SDET, Node JS, React, Oracle, and UNIX, to effectively perform
                job responsibilities.
              </p>
              <p className="py-2">
                Accept a Bachelor's degree (or foreign education equivalent to
                same) either in Computer Science, Computer Applications,
                Information Technology, Information Systems, Science,
                Technology, Business, Engineering (any), or a related field. The
                employer is open to considering any suitable combination of
                education, training, or experience. No telecommuting. EOE.
                Full-time, 40 hrs/week. Work in Herndon, VA, and other
                unanticipated locations within Washington DC MSA. May require
                travel/relocation to customer locations, with approximately 20%
                travel within the Washington DC MSA, depending on factors such
                as project phases initial set-up or final implementation or
                client requirements, and the project's nature. Work schedule
                8am-5pm, Mon-Fri. Send resume to JOB#IDB124, HR Dept., Idexcel
                Inc, 459 Herndon Pkwy, Suite #10, Herndon, VA 20170 (or)
                <a
                  href="mailto:usrecruitment@idexcel.com"
                  className="text-danger textDecoration"
                >
                  {" "}
                  usrecruitment@idexcel.com
                </a>
              </p>
              <div className="d-flex justify-content-end mt-1">
                <b className="fw-semibold mx-2">Posted Date:</b> 11/18/2024
              </div>
            </Row>
            {/* <a
              href="https://www.idexcel.com/portal/#/jobs"
              target="_blank"
              className="button"
            >
              All Job Openings
            </a> */}
          </section>
        </Container>
      </section>
    </div>
  );
};

export default CurrentOpenings;
